<template>
  <el-dialog
    no="dialog"
    append-to-body
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectLocation')"
    width="650px"
    :close-on-click-modal="false"
  >
    <div class="grid-view">
      <div class="main-content">
        <div class="filters">
          <el-form :inline="true" :label-width="$selectByLang('60px', '70px')" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_CityName')">
              <el-input
                v-model="filter.likeName"
                no="likeName"
                :placeholder="$t('common.tips.fuzzySearch')"
                style="width:310px"
              />
            </el-form-item>
            <el-form-item>
              <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          no="grid"
          :show-side-bar="false"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper" style="padding-right:0px;">
        <cargo-pagination
          v-show="total>0"
          no="pagination"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <span slot="footer">
      <el-button no="add" type="primary" @click="addFromPlatform">{{ $t('CargoMsg.Cargo_add') }}</el-button>
      <el-button no="cancel" @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import * as locationApi from '@/api/location'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'LocationSearchDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        isRowSelectable: function(row) {
          return row.data && !row.data.isAdded
        },
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_CityCode'),
          field: 'code',
          width: 400,
          suppressMenu: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityName'),
          field: 'englishName',
          width: 400,
          suppressMenu: true
        }, {
          headerName: this.$t('baseInfo.city.country'),
          field: 'countryCode',
          width: 400,
          suppressMenu: true
        }
      ],
      rowData: [],
      gridApi: null,
      innerVisible: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    onGridReady(params) {
      const self = this
      self.gridApi = params.api
      self.onGridDateRendered()
    },
    onGridDateRendered() {
      const self = this
      const columnApi = self.gridApi.columnController.columnApi
      const columnIds = []
      self.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      locationApi.getLocationList(self.filter).then(res => {
        const list = res.data.list
        if (list) {
          self.rowData = list
          self.filter.pageNum = res.data.pageNum
          self.filter.pageSize = res.data.pageSize
          self.total = Number(res.data.total)
        }
      }).finally(() => loading.close())
    },
    addFromPlatform() {
      const cell = this.gridOptions.api.getFocusedCell()
      const currentRow = cell ? this.rowData[cell.rowIndex] : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log(currentRow)
      this.$emit('addCallBack', currentRow)
      this.closeHandler()
    },
    closeHandler() {
      this.$emit('close')
    }
  }
}
</script>

<style>
</style>
